<script>
import CallDo from './CallDo';
export default {
  name: 'CallReload',
  props: {
    url: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      default: 'post',
    },
  },
  methods: {
    success() {
      window.location.reload(true);
    },
  },
  render(createElement) {
    return createElement(
      CallDo,
      {
        props: {
          url: this.url,
          method: this.method,
          success: this.success,
        },
      },
      [this.$scopedSlots.default]
    );
  },
};
</script>
